import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { getSmartPVMSOverviewApi, getSmartPVMSPlantInvertersApi } from '@/api/otherSources';

import dayjs from 'dayjs';
var LEVEL_ORDER = {
  fault: 0,
  warn: 1,
  info: 2
};
export default {
  name: 'SmartPVMSPanel',
  data: function data() {
    return {
      loading: false,
      plants: [],
      errors: [],
      fetchedAt: null,
      stale: false,
      opened: {},
      detail: {},
      detailLoading: {},
      detailError: {}
    };
  },
  computed: {
    fetchedAtText: function fetchedAtText() {
      return this.fetchedAt ? dayjs(this.fetchedAt).format('MM/DD HH:mm') : '';
    },
    allAlerts: function allAlerts() {
      return this.plants.flatMap(function (p) {
        return p.alerts.map(function (a) {
          return _objectSpread(_objectSpread({}, a), {}, {
            plantName: p.name,
            plantNo: p.plantNo
          });
        });
      }).sort(function (a, b) {
        return LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level];
      });
    },
    faultCount: function faultCount() {
      return this.countLevel('fault');
    },
    warnCount: function warnCount() {
      return this.countLevel('warn');
    },
    infoCount: function infoCount() {
      return this.countLevel('info');
    },
    sortedPlants: function sortedPlants() {
      // 有問題的排前面，維運不用自己找
      return _toConsumableArray(this.plants).sort(function (a, b) {
        var _LEVEL_ORDER$a$level, _LEVEL_ORDER$b$level;
        return ((_LEVEL_ORDER$a$level = LEVEL_ORDER[a.level]) !== null && _LEVEL_ORDER$a$level !== void 0 ? _LEVEL_ORDER$a$level : 3) - ((_LEVEL_ORDER$b$level = LEVEL_ORDER[b.level]) !== null && _LEVEL_ORDER$b$level !== void 0 ? _LEVEL_ORDER$b$level : 3);
      });
    },
    kpis: function kpis() {
      var _this = this;
      var sum = function sum(fn) {
        return _this.plants.reduce(function (s, p) {
          return s + (fn(p) || 0);
        }, 0);
      };
      var capacity = sum(function (p) {
        return p.capacity;
      });
      var energy = sum(function (p) {
        return p.energyToday;
      });
      var prs = this.plants.map(function (p) {
        return p.prToday;
      }).filter(function (v) {
        return v != null;
      });
      var avgPr = prs.length ? prs.reduce(function (s, v) {
        return s + v;
      }, 0) / prs.length : null;
      return [{
        label: '案場數',
        value: this.plants.length,
        unit: ' 座',
        tone: ''
      }, {
        label: '今日總發電',
        value: this.fmt(energy, 1),
        unit: ' kWh',
        tone: ''
      }, {
        label: '即時總發電功率',
        value: this.fmt(sum(function (p) {
          return p.instantPower;
        }), 1),
        unit: ' kW',
        tone: ''
      }, {
        label: '等效小時',
        value: capacity ? this.fmt(energy / capacity, 2) : '—',
        unit: ' h',
        tone: ''
      }, {
        label: '今日平均 PR',
        value: avgPr == null ? 'NA' : this.fmt(avgPr, 1),
        unit: avgPr == null ? '' : '%',
        tone: avgPr != null && avgPr < 70 ? 'is-warn' : '',
        hint: "\u50C5\u8A08\u5165\u5DF2\u8A2D\u7F6E\u65E5\u7167\u8A08\u7684 ".concat(prs.length, " \u5EA7\u6848\u5834\uFF0C\u5176\u9918\u7121\u6CD5\u8A08\u7B97 PR")
      }, {
        label: '故障（紅燈）',
        value: this.faultCount,
        unit: ' 件',
        tone: this.faultCount ? 'is-fault' : ''
      }];
    }
  },
  methods: {
    countLevel: function countLevel(level) {
      return this.allAlerts.filter(function (a) {
        return a.level === level;
      }).length;
    },
    load: function load() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getSmartPVMSOv, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return getSmartPVMSOverviewApi();
              case 4:
                _yield$getSmartPVMSOv = _context.sent;
                data = _yield$getSmartPVMSOv.data;
                _this2.plants = data.plants;
                _this2.errors = data.errors;
                _this2.fetchedAt = data.fetchedAt;
                _this2.stale = data.stale;
                _this2.detail = {};
                _context.next = 16;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);
                _this2.errors = [{
                  msg: '資料讀取失敗，請洽資訊人員'
                }];
              case 16:
                _context.prev = 16;
                _this2.loading = false;
                return _context.finish(16);
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13, 16, 19]]);
      }))();
    },
    toggle: function toggle(p) {
      this.$set(this.opened, p.plantNo, !this.opened[p.plantNo]);
      if (this.opened[p.plantNo] && !this.detail[p.plantNo]) this.loadDetail(p);
    },
    loadDetail: function loadDetail(p) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _yield$getSmartPVMSPl, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$set(_this3.detailLoading, p.plantNo, true);
                _this3.$set(_this3.detailError, p.plantNo, '');
                _context2.prev = 2;
                _context2.next = 5;
                return getSmartPVMSPlantInvertersApi(p.plantNo);
              case 5:
                _yield$getSmartPVMSPl = _context2.sent;
                data = _yield$getSmartPVMSPl.data;
                _this3.$set(_this3.detail, p.plantNo, data);
                _context2.next = 13;
                break;
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                _this3.$set(_this3.detailError, p.plantNo, '逆變器資料讀取失敗，請洽資訊人員');
              case 13:
                _context2.prev = 13;
                _this3.$set(_this3.detailLoading, p.plantNo, false);
                return _context2.finish(13);
              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10, 13, 16]]);
      }))();
    },
    focusPlant: function focusPlant(plantNo) {
      var _this4 = this;
      var p = this.plants.find(function (x) {
        return x.plantNo === plantNo;
      });
      if (!p) return;
      if (!this.opened[plantNo]) this.toggle(p);
      this.$nextTick(function () {
        var el = _this4.$refs["plant-".concat(plantNo)];
        if (el && el[0]) el[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    },
    prHint: function prHint(p) {
      return p.prToday == null ? '本案場未設置日照計或日照計無讀值，無法計算 PR' : '等效小時 ÷ 當日累積日照，兩者同為當日累計，統計區間一致';
    },
    todayChart: function todayChart(p) {
      return {
        chart: {
          height: 180,
          spacing: [6, 4, 2, 0],
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: true,
          itemStyle: {
            fontSize: '11px'
          }
        },
        xAxis: {
          categories: p.curve.map(function (c) {
            return dayjs(c.t).format('HH:mm');
          }),
          tickInterval: Math.max(1, Math.round(p.curve.length / 8)),
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        yAxis: [{
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        }, {
          title: {
            text: null
          },
          opposite: true,
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        }],
        tooltip: {
          shared: true,
          valueDecimals: 1
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false
            }
          }
        },
        series: [{
          name: '發電功率 kW',
          type: 'area',
          data: p.curve.map(function (c) {
            return c.power;
          }),
          color: '#7cb5ec',
          fillOpacity: 0.25
        }, {
          name: '日照 W/m²',
          type: 'spline',
          yAxis: 1,
          data: p.curve.map(function (c) {
            return c.irradiance;
          }),
          color: '#f0ad4e'
        }]
      };
    },
    maxEnergy: function maxEnergy(inverters) {
      return Math.max.apply(Math, _toConsumableArray(inverters.map(function (i) {
        return i.energy || 0;
      })).concat([1]));
    },
    fmt: function fmt(v) {
      var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return v == null ? '—' : Number(v).toFixed(digits);
    },
    pct: function pct(v, max) {
      if (!v || !max) return '0%';
      return "".concat(Math.min(100, v / max * 100).toFixed(1), "%");
    },
    prClass: function prClass(pr) {
      if (pr == null) return '';
      if (pr < 70) return 'is-fault';
      if (pr < 80) return 'is-warn';
      return 'is-ok';
    }
  },
  mounted: function mounted() {
    this.load();
  }
};